export default "__VITE_ASSET__B15jCI0X__"